/*
This is a resaonable summary of the rules without combing the RFC

https://www.cisco.com/assets/sol/sb/WAP321_Emulators/WAP321_Emulator_v1.0.0.3/help/Wireless05.html

*/
export const ssidRegex =
  /^(?![ !#;])^(?:[# !%-*,->@-Z^-~]){1,31}[#!%-*,->@-Z^-~]$/;
